export default __webpack_public_path__ + "static/media/marker1.2a0661bc.png";